import React from 'react'
import './styles.scss'

export const NoiseScale = () => {
  // const [playSound, setPlaySound] = useState(false)
  // const audioContext = useRef(new AudioContext())
  // const oscillator = useRef(audioContext.current.createOscillator())
  // oscillator.current.type = 'sine'
  // oscillator.current.connect(audioContext.current.destination)

  // useEffect(() => {
  //   if (oscillator) {
  //     try {
  //       playSound === true
  //         ? oscillator.current.start()
  //         : oscillator.current.stop()
  //     } catch (e) {
  //       console.log(e)
  //     }
  //   }
  // }, [playSound])

  return (
    <div className='noise-scale'>
      <div className='ui center aligned container'>
        <h4 className='ui header'>L'échelle du bruit</h4>
        <img
          className='infog-mobile ui mobile only'
          src={require('./echelle_du_bruit_mobile.svg')}
        />
        <img
          className='infog-desktop ui mobile hidden'
          src={require('./echelle_du_bruit_desktop.svg')}
        />
        <figcaption>Infographie: Océane Haenni</figcaption>
      </div>
    </div>
  )
}
